/** Managed layout pinned to Codex 0.153.4; publishing alone does not prove durable custody. */
export const CODEX_NATIVE_STATE_FORMAT = "codex-0.153.4-managed-v1";

/** Positive state absence/incompatibility only; never an auth, transport, or policy failure. */
export class CodexNativeStateUnavailable extends Error {
  constructor() {
    super("CODEX_NATIVE_STATE_UNAVAILABLE");
    this.name = "CodexNativeStateUnavailable";
  }
}
